<!-- 路径搜索输入 -->
<template>
  <div class="div_ucSearchInput">

    <div class="div_navbar">
      <div v-bind:class="{div_car:true,div_selectCarOrBus:ucSetting.selectIsDrive}">
        <i
          v-bind:class="{i_car:true,i_car_select:ucSetting.selectIsDrive}"
          @click="_imgDriveClickHandler"
        ></i>
      </div>

      <div v-bind:class="{div_bus:true,div_selectCarOrBus:ucSetting.selectIsBus}">
        <i
          v-bind:class="{i_bus:true,i_bus_select:ucSetting.selectIsBus}"
          @click="_imgBusClickHandler"
        ></i>
      </div>

      <div
        class="clear_route"
        @click="_clearRouteClickHandler"
      >清除路线</div>

    </div>

    <div class="div_search_input">

      <div>
        <i
          class="i_viaPOISuggest"
          @click="_suggestKeySwitchHandler"
        >
        </i>

        <el-input
          type="text"
          placeholder="请输入起点"
          v-model="startPointSuggestKey"
        ></el-input>

      </div>

      <div
        v-show="searchType==='national_drive'"
        class="div_viaPOISuggest"
        v-for="(item,index) in driveViaPoints"
        :key="item.id"
      >
        <i class="i_viaPOISuggest"></i>
        <el-input
          type="text"
          v-model="item.suggestKey"
          :placeholder="item.tip"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-remove"
            @click="_removeViaPointHandler(item,index)"
          ></i>
        </el-input>
      </div>

      <div class="div_end">
        <i class="i_endPOISuggest"></i>
        <el-input
          style=""
          type="text"
          placeholder="请输入终点"
          v-model="endPointSuggestKey"
        ></el-input>
      </div>

    </div>

    <div class="div_search">

      <span
        v-show="searchType==='national_drive'"
        class="span_drive_addVia"
        @click="_addViaPointHandler"
      >
        <i class="i_drive_addVia"></i>
        添加途经点
      </span>

      <span
        class="span_search"
        @click="_searchClickHandler"
      >搜索</span>
    </div>

  </div>
</template>

<script>
import {
  RouteSearchParams,
  UCRouteEvent,
  RoutePOIInfo,
  RouteSearchType
} from "./UCRouteJs.js";

export default {
  name: "UCSearchInput",
  data() {
    return {
      ucSetting: {
        selectIsDrive: true,

        selectIsBus: false
      },
      

      //起点建议词
      startPointSuggestKey: null,

      //原始线路起点信息
      oriRouteStartPointInfo: null,

      //终点建议词
      endPointSuggestKey: null,

      //原始线路终点信息
      oriRouteEndPointInfo: null,

      //途经点
      driveViaPoints: new Array(),
      
      //搜索类型
      searchType: RouteSearchType.national_drive
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init(searchParams) {
      if (searchParams) {
        if (searchParams.startPoint) {
          this.startPointSuggestKey = searchParams.startPoint.suggestKey;
          this.oriRouteStartPointInfo = searchParams.startPoint;
        }

        if (searchParams.endPoint) {
          this.endPointSuggestKey = searchParams.endPoint.suggestKey;
          this.oriRouteEndPointInfo = searchParams.endPoint;
        }

        ////如果为公交换乘，没有途经点，只有驾车才有途经点
        if (
          searchParams.driveViaPoints &&
          this.searchType === RouteSearchType.national_drive
        ) {
          this.driveViaPoints = searchParams.driveViaPoints;
        }
      } else {

        this.startPointSuggestKey = null;
        this.endPointSuggestKey = null;
        this.oriRouteStartPointInfo=null;
        this.oriRouteEndPointInfo=null;

        this.driveViaPoints = new Array();
      }
    },

    getSearchParams() {
      return this._createSearchParams();
    },

    off_searchClick(callback) {
      if (callback) {
        this.$off(UCRouteEvent.UCSearchInput_searchClick, callback);
      }
    },

    on_searchClick(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCSearchInput_searchClick, callback);
      }
    },

    off_searchTypeChange(callback) {
      if (callback) {
        this.$off(UCRouteEvent.UCSearchInput_searchTypeChange, callback);
      }
    },

    on_searchTypeChange(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCSearchInput_searchTypeChange, callback);
      }
    },

    off_clearRoute(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCSearchInput_clearRoute, callback);
      }
    },

    on_clearRoute(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCSearchInput_clearRoute, callback);
      }
    },

    /**
     * 创建搜索参数对象
     */
    _createSearchParams() {
      let searchParams = new RouteSearchParams();
      let startPOIInfo = RoutePOIInfo.createStartPoint();
      startPOIInfo.suggestKey = this.startPointSuggestKey;
      startPOIInfo.description = "起点：" + this.startPointSuggestKey;
      //如果原始
      if (
        this.oriRouteStartPointInfo &&
        this.oriRouteStartPointInfo.POI &&
        this.oriRouteStartPointInfo.POI.name === this.startPointSuggestKey
      ) {
        startPOIInfo.POI = this.oriRouteStartPointInfo.POI;
      }

      let endPOIInfo = RoutePOIInfo.createEndPoint();
      endPOIInfo.suggestKey = this.endPointSuggestKey;
      endPOIInfo.description = "终点：" + this.endPointSuggestKey;
      if (
        this.oriRouteEndPointInfo &&
        this.oriRouteEndPointInfo.POI &&
        this.oriRouteEndPointInfo.POI.name === this.endPointSuggestKey
      ) {
        endPOIInfo.POI = this.oriRouteEndPointInfo.POI;
      }

      let viaPoints = new Array();

      //公交没有途径点，只有驾车才有
      if (this.searchType === RouteSearchType.national_drive) {
        let tempOriViaPnt = null;
        let tempViaPnt = null;
        for (
          let tempViaPntIndex = 0;
          tempViaPntIndex < this.driveViaPoints.length;
          tempViaPntIndex++
        ) {
          tempOriViaPnt = this.driveViaPoints[tempViaPntIndex];
          if (!tempOriViaPnt.suggestKey) continue;

          tempViaPnt = RoutePOIInfo.createViaPoint();
          //如果原始途经点含有poi信息，并且关键字和poi信息一致，将原有poi赋给新途经点
          if (
            tempOriViaPnt.POI &&
            tempOriViaPnt.POI.name === tempOriViaPnt.suggestKey
          ) {
            tempViaPnt.POI = tempOriViaPnt.POI;
          }

          tempViaPnt.suggestKey = tempOriViaPnt.suggestKey;
          tempViaPnt.description = "途径点：" + tempOriViaPnt.suggestKey;
          viaPoints.push(tempViaPnt);
        }
      }

      searchParams.startPoint = startPOIInfo; //
      searchParams.endPoint = endPOIInfo;
      searchParams.driveViaPoints = viaPoints;
      searchParams.searchType = this.searchType;

      return searchParams;
    },

    _searchClickHandler() {
      if (!this.startPointSuggestKey || !this.endPointSuggestKey) return;

      //点击搜索时，需要重新选择线路poi点
      this.oriRouteStartPointInfo=null;
      this.oriRouteEndPointInfo=null;
      RoutePOIInfo.setNullForPOIAttribute(this.driveViaPoints);
      


      let searchParams = this._createSearchParams();

      this.$emit(UCRouteEvent.UCSearchInput_searchClick, searchParams);
    },

    /**
     * 添加途经点
     */
    _addViaPointHandler() {
      if (this.driveViaPoints && this.driveViaPoints.length < 5) {
        let newViaPnt = RoutePOIInfo.createViaPoint();
        this.driveViaPoints.push(newViaPnt);
      }
    },

    /**
     * 移除途经点
     */
    _removeViaPointHandler(item, index) {
      this.driveViaPoints.splice(index, 1);
    },

    _suggestKeySwitchHandler() {
      let tempKey = this.startPointSuggestKey;
      this.startPointSuggestKey = this.endPointSuggestKey;
      this.endPointSuggestKey = tempKey;
    },

    _searchTypeChangeHandler() {
      let searchParams = this._createSearchParams();
      this.$emit(UCRouteEvent.UCSearchInput_searchTypeChange, searchParams);
    },

    _imgDriveClickHandler() {
      if (this.searchType !== RouteSearchType.national_drive) {
        this.searchType = RouteSearchType.national_drive;

        this._searchTypeChangeHandler();
      }

      this.ucSetting.selectIsDrive = true;
      this.ucSetting.selectIsBus = false;
    },

    _imgBusClickHandler() {
      this.driveViaPoints = new Array();

      if (this.searchType !== RouteSearchType.national_busTransfer) {
        this.searchType = RouteSearchType.national_busTransfer;

        this._searchTypeChangeHandler();
      }

      this.ucSetting.selectIsDrive = false;
      this.ucSetting.selectIsBus = true;
    },

    /**
     * 清除路线
     */
    _clearRouteClickHandler() {
      this.startPointSuggestKey = null;
      this.endPointSuggestKey = null;
      this.driveViaPoints = new Array();

      this.$emit(UCRouteEvent.UCSearchInput_clearRoute, null);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/input.scss";

.div_ucSearchInput {
  overflow: auto;

  .div_navbar {
    height: 36px;
    line-height: 36px;
    background: #f2f2f2;

    .div_car {
      width: 30px;
      height: 30px;
      float: left;
      margin-left: 30px;
      margin-top: 3px;
      cursor: pointer;
    }

    .div_bus {
      width: 30px;
      height: 30px;
      float: left;
      margin-left: 30px;
      margin-top: 3px;
      cursor: pointer;
    }

    .div_selectCarOrBus {
      border-radius: 15px;
      background: #3385ff;
    }

    .i_car {
      background: url("../../../assets/onlineMap/icon.png");
      background-repeat: no-repeat;
      display: inline-block;
      width: 20px;
      height: 16px;
      margin-left: 5px;
      background-position: -32px -181px;
    }

    .i_car_select {
      background-position: -89px -183px;
    }

    .i_bus {
      background: url("../../../assets/onlineMap/icon.png");
      width: 17px;
      height: 20px;
      margin-top: 5px;
      margin-left: 6px;
      background-position: -62px -179px;
      background-repeat: no-repeat;
      display: inline-block;
    }

    .i_bus_select {
      background-position: -119px -179px;
    }

    .clear_route {
      font-family: microsoft yahei, arial, tahoma, helvetica, sans-serif;
      font-size: 13px;
      font-style: italic;
      float: right;
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .div_search_input {
    position: relative;
    background: #f2f2f2;
    padding: 10px 0;

    input {
      width: 250px;
      height: 30px;
      // padding: 0 15px;
      // float: left;
      // margin-left: 4px;
    }

    .div_viaPOISuggest {
      // padding: 5px 2px;
      margin-top: 10px;
    }

    .i_viaPOISuggest {
      background: url("../../../assets/onlineMap/icon.png") #fff;
      background-repeat: no-repeat;
      float: left;
      width: 16px;
      height: 16px;
      margin: 8px 10px 8px 36px;

      background-position: -512px -154px;
    }

    .div_end {
      margin-top: 10px;

      .i_endPOISuggest {
        background: url("../../../assets/onlineMap/icon.png") #fff;
        background-repeat: no-repeat;
        float: left;
        width: 16px;
        height: 16px;
        margin: 8px 10px 8px 36px;

        background-position: -536px -154px;
      }
    }
  }
}

.div_search {
  // height: 32px;
  background: #f2f2f2;
  padding-bottom: 2px;
  float: left;
  width: 100%;

  .span_drive_addVia {
    margin-top: 10px;
    margin-left: 40px;
    font-size: 12px;
    color: #3385ff;
    cursor: pointer;
    float: left;
  }

  .i_drive_addVia {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    background-repeat: no-repeat;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 4px;
    background-position: -200px -185px;
  }

  .span_search {
    float: right;
    margin-right: 19px;
    padding: 6px 20px;
    border: 1px solid #3385ff;
    color: #fff;
    background: #3385ff;
    font-size: 13px;
    cursor: pointer;
  }
}

/deep/.el-input__inner {
  padding: 0 5px !important;
}
</style>